export default __webpack_public_path__ + "static/media/hn.084f590f.svg";